@use '@/scss/underscore' as _;

.notice {
  margin: _.unit(2) 0;
}
